/** Rótulos em português para tipo e status de protocolo (UI). */

export const TIPO_LABELS = {
  aprovacao_obra: 'Aprovação de obra',
  regularizacao: 'Regularização',
  reforma: 'Reforma',
  habite_se: 'Habite-se',
};

export function labelTipo(tipo) {
  if (!tipo) return '—';
  return TIPO_LABELS[tipo] || tipo.replace(/_/g, ' ');
}

export function labelStatus(status) {
  if (!status) return '—';
  return status.replace(/_/g, ' ');
}
